import React from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import promoColors from 'theme/promoColors';
import promoMedia from 'theme/promoMedia';

const Container = styled.div`
    background: ${(props) => promoColors[props.bgColor]};
    overflow: hidden;
    padding-bottom: ${(props) => (props.noIndent ? null : '32px')};

    ${promoMedia.tablet744} {
        padding-bottom: ${(props) => (props.noIndent ? null : '48px')};
    }

    ${promoMedia.desktop1440} {
        padding-bottom: ${(props) => (props.noIndent ? null : '64px')};
    }
`;

export const PromoPageContainer = (props) => {
    return (
        <Container bgColor={props.bgColor} noIndent={props.noIndent} data-testid={props.dataTestId}>
            {props.children}
        </Container>
    );
};

PromoPageContainer.propTypes = {
    bgColor: PropTypes.oneOf(['white', 'purple5', 'gray5', 'eggshell01', 'eggshell02', 'eggshell03']),
    noIndent: PropTypes.bool,
};
